import React, { useState, useEffect } from "react"
import { useNavigate } from "react-router-dom"
import Button from "../../../components/ui/Button"
import { subscribeLiveClasses } from "../../../utils/liveClassHelpers"

// Surfaces any live class, across every org the learner has an enrolled
// course with, that is currently "live" and matches one of their
// enrolled courses. Renders nothing when nothing is live.
const LiveNowBanner = ({ enrolledCourses }) => {
  const navigate = useNavigate()
  const [liveByOrg, setLiveByOrg] = useState({})

  const orgCourseKey = (enrolledCourses || [])
    .map((e) => `${e?.enrollment?.orgId}:${e?.enrollment?.courseId}`)
    .sort()
    .join(",")

  useEffect(() => {
    const byOrg = {}
    ;(enrolledCourses || []).forEach((e) => {
      const orgId = e?.enrollment?.orgId
      if (!orgId) return
      if (!byOrg[orgId]) byOrg[orgId] = new Set()
      byOrg[orgId].add(e?.enrollment?.courseId)
    })

    const unsubscribes = Object.entries(byOrg).map(([orgId, courseIds]) =>
      subscribeLiveClasses(orgId, (all) => {
        const live = (all || []).filter((c) => c?.status === "live" && courseIds.has(c?.courseId))
        setLiveByOrg((prev) => ({ ...prev, [orgId]: live }))
      })
    )

    return () => unsubscribes.forEach((u) => u())
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [orgCourseKey])

  const liveSessions = Object.entries(liveByOrg).flatMap(([orgId, classes]) =>
    (classes || []).map((c) => ({ ...c, orgId }))
  )

  if (liveSessions.length === 0) return null

  const courseTitleFor = (orgId, courseId) =>
    enrolledCourses?.find((e) => e?.enrollment?.orgId === orgId && e?.enrollment?.courseId === courseId)?.course?.title

  return (
    <div className="bg-gradient-to-r from-destructive to-destructive/80 rounded-2xl p-4 sm:p-5 flex flex-col sm:flex-row sm:items-center gap-3 sm:gap-4 shadow-lg">
      <div className="flex items-center gap-3 flex-1 min-w-0">
        <span className="flex-shrink-0 flex items-center gap-1.5 bg-white/20 text-white text-xs font-bold px-2 py-1 rounded-full">
          <span className="w-1.5 h-1.5 rounded-full bg-white animate-pulse" /> LIVE
        </span>
        <div className="min-w-0">
          <p className="text-white font-semibold truncate">
            {liveSessions[0]?.title}
            {liveSessions.length > 1 ? ` + ${liveSessions.length - 1} more live now` : ""}
          </p>
          <p className="text-white/80 text-xs truncate">
            {courseTitleFor(liveSessions[0]?.orgId, liveSessions[0]?.courseId)}
          </p>
        </div>
      </div>
      <Button
        variant="secondary"
        iconName="Video"
        iconPosition="left"
        onClick={() => navigate(`/live-classroom-viewer?orgId=${liveSessions[0]?.orgId}&classId=${liveSessions[0]?.id}`)}
      >
        Join Now
      </Button>
    </div>
  )
}

export default LiveNowBanner